<footer class="site-footer">
  <div class="footer-grid">
    <div class="footer-brand">
      <img src="assets/img/Splex-Innovation-Logo.png" alt="SPLEX Innovation">
      <p>Building practical digital solutions that help businesses build, innovate and grow.</p>
      <div class="socials">
        <a href="https://www.linkedin.com/company/splex-innovation?trk=blended-typeahead" target="_blank"
          aria-label="LinkedIn"><i class="bi bi-linkedin"></i></a>
        <!-- <a href="#" aria-label="Instagram"><i class="bi bi-instagram"></i></a>
        <a href="#" aria-label="Facebook"><i class="bi bi-facebook"></i></a> -->
      </div>
    </div>

    <div>
      <h4>Company</h4>
      <a routerLink="/">Home</a>
      <a routerLink="/aboutus">About Us</a>
      <a routerLink="/services">Services</a>
      <a routerLink="/pricing">Pricing</a>
      <a routerLink="/contactus">Contact Us</a>
    </div>

    <div>
      <h4>Services</h4>
      <a routerLink="/services">Website Design</a>
      <a routerLink="/services">Application Development</a>
      <a routerLink="/services">Support & Maintenance</a>
      <a routerLink="/services">Digital Solutions</a>
    </div>

    <div>
      <h4>Contact</h4>
      <p>Email: info@splexinov.com</p>
      <p>Let's discuss your next project.</p>
      <a class="footer-contact" routerLink="/contactus">Start a Conversation <i class="bi bi-arrow-right"></i></a>
    </div>
  </div>

  <div class="footer-bottom">
    <span>© {{ year }} SPLEX Innovation. All Rights Reserved.</span>
    <span>Build • Innovate • Grow</span>
  </div>
</footer>